<template>
	<div>
		<div class="mb-2 text-right">
			<button
				class="btn btn-primary justify-center items-center mb-4 mr-2"
				data-cy="download-file-button"
				@click="downloadAppointments()"
			>
				<b-icon icon="download" class="mr-2" />
				{{ $t('download') }}
			</button>
		</div>
		<div class="list-group border-radius-2 no-border">
			<div v-for="slot in slots" class="list-group-item" :key="slot.ttevent_id">
				{{$t(`dayname-short-${slot.dayofweek}`)}}
				{{slot.ttpatientslot_time}} |
				{{slot.ttsessiontype_name}}
				{{slot.ttroom_name}} |
				{{$t('{n}-appointments' , {n: slot.num_students})}}
				{{$t('{n}-assists' , {n: slot.num_assists})}}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	components: {
	},
	data() {
		return {
			slots: []
		}
	},
	mounted() {
		this.getSlots();
	},
	methods: {
		getSlots: function () {
			this.$cfetch(`${this.$settings.APIBaseURL}/timetable/appointments/getslots`, {
				data: {
					tttimetable_id: Number(this.$route.params["timetableid"]),
					programme: this.$route.params["programme"],
					year: this.$route.params["year"]
				},
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.slots = res.slots;
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-load-timetable");
					}
				}
			});
		},
		downloadAppointments(){
			window.open(
				`${this.$settings.APIBaseURL}/timetable/appointments/download?username=${this.$UserSession.getValue.call(
					this,
					"username"
				)}&authToken=${this.$UserSession.getValue.call(this, "authToken")}&tttimetable_id=${(this.$route.params["timetableid"]?Number(this.$route.params["timetableid"]):'')}&programme=${(this.$route.params["programme"]?this.$route.params["programme"]:'')}&year=${(this.$route.params["year"]?this.$route.params["year"]:'')}&group=${(this.$route.params["group"]?this.$route.params["group"]:'')}`
			);
		}
	}
};
</script>
